import { all } from "redux-saga/effects";
import { combineReducers } from "redux";

import * as auth from "../app/modules/Auth/_redux/authRedux";
import { customersSlice } from "../app/modules/ECommerce/_redux/customers/customersSlice";
import { productsSlice } from "../app/modules/ECommerce/_redux/products/productsSlice";
import { remarksSlice } from "../app/modules/ECommerce/_redux/remarks/remarksSlice";
import { specificationsSlice } from "../app/modules/ECommerce/_redux/specifications/specificationsSlice";

import { productSlice } from "../app/redux/product/productSlice";
import { authSlice } from "../app/redux/auth/authSlice";
import { Slice as facilityPlanSlice } from "../app/redux/facilityPlan/facilityPlanSlice";
import { Slice as stepSlice } from "../app/redux/activeStep/activeStepSlice";
import { Slice as summaryNotice } from "../app/redux/summaryCount/summaryCountSlice";
import { Slice as summaryCount } from "../app/store/redux/cartSummary/cartCountSlice";
import ShellConfigSlice from "../app/redux/styleConfig/styleSlice";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  customers: customersSlice.reducer,
  products: productsSlice.reducer,
  remarks: remarksSlice.reducer,
  specifications: specificationsSlice.reducer,

  product: productSlice.reducer,
  auth2: authSlice.reducer,
  facilityPlan: facilityPlanSlice.reducer,
  step: stepSlice.reducer,
  summatyNotice: summaryNotice.reducer,
  summatyCount: summaryCount.reducer,
  style: ShellConfigSlice,
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
